import React, { useEffect, useState,useRef} from 'react';
import { Typography, IconButton, useTheme, Box } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { MENU_BACK_ICON, DARK_MENU_BACK_ICON, LOGOUT_ICON, DARK_LOGOUT_ICON } from "../assets/constants/Icons";

import { useTranslation } from 'react-i18next';
import { APP_ENGLISH_VIOLET_COLOR, APP_WHITE_COLOR } from '../assets/constants/Colors';
import { ASSIGNED, RETURN, TOAST_SUCCESS, BUTTON_PRIMARY, BUTTON_WARNING } from '../assets/constants/Constants';
import { LOCAL_STORAGE, LS_CUSTOMER, LS_LOCKER_BANK_INFO, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, LS_TRANSACTION_COMPLETED, USER_INFO } from '../assets/constants/BrowserStorageKeys';
import { getAndThenRemoveSecureItemFromSpecificStorage, getSecureItemFromSpecificStorage, } from '../lib/BrowserStorageAccessMiddleware';
import ShowToast from './ToastComponent';
import { clearLocalStorageForUser, getPathForNextPage, getUnitLabelParams } from '../lib/Utils';
import CustomDialog from './CustomDialog';
import { ACCESS_LOCKER_BANK, LOGIN } from '../assets/constants/PageList';

const SubHeader = ({ title, alertback, hide, condition,onLogout  }) => {
    const history = useHistory();
    const unblockRef = useRef(null);
    const theme = useTheme();
    const { t } = useTranslation();
    const colorScheme = theme.palette.mode;
    const [isDialogVisible, setIsDialogVisible] = useState(false); 
    const [isBackDialogVisible, setIsBackDialogVisible] = useState(false);
    const [dialogMessage, setDialogMessage] = useState("");
    const [dialogtitle, setDialogTitle] = useState(t('logout'))
    const assignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const unitLabelParams = getUnitLabelParams(lockerBankInfo?.LockerBankType ?? lockerBankInfo?.bank_type, t);
    const isAuthenticatedUser = Boolean(
        getSecureItemFromSpecificStorage(LOCAL_STORAGE, USER_INFO)
    );
    const [transactionState, setTransactionState] = useState(
    getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TRANSACTION_COMPLETED) || false
    );
    useEffect(() => {
        if (transactionState) {
            if (unblockRef.current) {
                unblockRef.current();
                unblockRef.current = null;
            }
        }
    }, [transactionState]);

    useEffect(() => {
        const storedTransaction = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TRANSACTION_COMPLETED);
        setTransactionState(storedTransaction || false);

        /*
            below function is used to Listen for block removal requests
        */
        const handleRemoveBlock = () => {
            if (unblockRef.current) {
                unblockRef.current();
                unblockRef.current = null;
            }
        };
        /*
        Listen for custom events when transaction state changes
        */
        const handleTransactionUpdate = (event) => {
            const newTransactionState = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TRANSACTION_COMPLETED);
            setTransactionState(newTransactionState || false);
        };
        
        window.addEventListener('removeHistoryBlock', handleRemoveBlock);
        window.addEventListener('transactionStateUpdated', handleTransactionUpdate);
        
        if (title === "/drop-parcel" && assignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value) {
            const unblock = history.block((tx) => {
                const currentTransactionState = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TRANSACTION_COMPLETED);
                if(currentTransactionState){
                    setDialogMessage(t('are_you_sure_to_logout'));
                    setDialogTitle(t('logout'));
                } else {
                    setDialogMessage(t('cancel_Transaction_With_Logout'));
                    setDialogTitle(t('cancel_Transaction_title'));
                }
                
                setIsBackDialogVisible(true);
                return false;
            });
            
            unblockRef.current = unblock;
            
            return () => {
                if (unblockRef.current) {
                    unblockRef.current();
                    unblockRef.current = null;
                }
                window.removeEventListener('transactionStateUpdated', handleTransactionUpdate);
            };
        }
        
        // Cleanup for non-drop-parcel pages
        return () => {
            window.removeEventListener('transactionStateUpdated', handleTransactionUpdate);
        };
    }, [title, assignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value, history, t]);


const getPageTitle = (path) => {
        switch (path) {
            case "/about-screen":
                return t('aboutText');
            case "/support-screen":
                return t('supportText');
            case "/change-pin":
                return t('changePIN');
            case "/forget-pin":
                return t('forgetPINText');
            case "/team-locker":
                return t('teamLockerText', unitLabelParams);
            case "/personal-locker":
                return t('personalLockerText', unitLabelParams);
            case "/terms-and-conditions":
                return t('termAndconditionText');
            case "/organisation-list":
                return t('organizationListText');
            case "/my-lockers":
                return t('page_title_my_lockers', unitLabelParams);
            case "/select-locker-bank":
                return t('selectLockerBankText', unitLabelParams);
            case "/select-zone":
                return t('selectZoneText');
            case "/new-reserve-locker":
                if (condition?.scan_qr_code) {
                    return t('scanQRCode');
                }
                else if (condition?.scan_barcode) {
                    return t('scanBarcode');
                }
                return t('acessLockerText', unitLabelParams);
            case "/select-user":
                return t('selectUserText');
            case "/profile-update":
                return t('profileUpdateText');
            case "/connect-mobile":
                return t('linkPhoneText');
            case "/parcel-details":
                return t('parcelDetailsText');
            case "/assignments":
                return t('Select_Assignment_Text');
            case "/drop-parcel":
                if (condition?.status === ASSIGNED || condition?.status === RETURN) {
                    return t('pickupParcel')
                }
                return t('dropParcel');
            case "/notification":
                return t('notificationTitleText');
            case "/locker-list":
                return t('lockerListText', unitLabelParams);
            case "/locker-layout":
                return t('lockerLayoutText', unitLabelParams);
            case "/select-locker-size":
                return t('page_title_locker_size', unitLabelParams);
            case "/locker-more-options":
                return t('lockerDetailsText', unitLabelParams);
            case "/assign-locker":
                return t('assignLockerTitleText', unitLabelParams);
            case "/open-locker":
                return t('openLockerText', unitLabelParams);
            case "/open-parcel":
                return t('openParcelText');
            case "/payment-details":
                return t('paymentDetailsText');
            case "/payment-completion":
                return t('paymentCompletionText');
            case "/select-unit":
                return t('Select_Unit_Text');
            case "/swipe-to-open":
                return t('swipeToOpenText');
            case "/locker-opened":
                return t('page_title_locker_opened', unitLabelParams);
            case "/sublocation-one":
                return t('subLocationText');
            case "/sublocation-two":
                return t('subLocationText');
            case "/sublocation-three":
                return t('subLocationText');
            case "/account-details":
                return t('accountDetailsText');
            case "/my-rented-products":
                return t('myRentedProductsText');
            case "/faq":
                return t('faqText');
            case "/contact-us":
                return t('contactUsText');
            case "/privacy-policy":
                return t('privacyPolicyText');
            case "/parcel-owner":
                return t('Parcel_Owner_Text');
            case "/parcel-pickup-door-verification":
                return t('Door_Verification_Text');
            case "/invoice":
                return t('invoice_Page_Title', unitLabelParams);
            case"/user-account":
                return t('my_account_title')
            case 'cancel-policy':
                return t('cancelPolicyTitle')
            default:
                return "";
        }
    }

    const createTwoButtonAlert = () => {
        if (window.confirm(t('transaction_cancel'))) {
            history.push('/ReleaseParcelLoader')
        }
    };

    const onPressHandler = () => {
        if (title === "/drop-parcel" && assignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value) {
            if(transactionState){
                setDialogMessage(t('are_you_sure_to_logout'));
            }else{
                setDialogMessage(t('cancel_Transaction_With_Logout'));
            }
            setIsBackDialogVisible(true);
        } else if (title === "/user-account" && isAuthenticatedUser) {
            history.replace('/custom-drawer', { isDrawerOpened: true });
        } else if (alertback === true) {
            createTwoButtonAlert();
        } else {
            history.goBack();
        }
    };


const HandleShowModel = () => {
    if (title === "/user-account" && !isAuthenticatedUser) {
        return;
    }

    if (
        assignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value &&
        title === "/drop-parcel"
    ) {
        if (transactionState) {
        setDialogMessage(t("are_you_sure_to_logout"));
        setDialogTitle(t("button_logout"));
        } else {
        setDialogMessage(t("cancel_Transaction_With_Logout"));
        setDialogTitle(t("cancel_Transaction_title"));
        }
    } else {
        setDialogMessage(t("are_you_sure_to_logout"));
        setDialogTitle(t("button_logout"));
    }

    setIsDialogVisible(true);
    };


    

    /**
     * Continue without cancelling (just go back)
     */
    const handleContinueWithoutCancel = () => {
        setIsBackDialogVisible(false);
    };

    const handleBackDialogAccept = () => {
        setIsBackDialogVisible(false);
        handleLogout();
    };

    /**
   * Handles the logout functionality.
   * Clears user information and tokens from local storage.
   * Redirects the user to the login page.
   * @returns {null} Returns null if any required data is missing.
   * @throws {Error} Throws an error if there is an issue clearing app data.
   */
    const handleLogout = async () => {
        if (unblockRef.current) {
            unblockRef.current();
            unblockRef.current = null;
        }
        
        if (onLogout && assignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value) {
            if(! transactionState){
                onLogout();
            return;
            }
        }

        try {
            clearLocalStorageForUser(getAndThenRemoveSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER))
            ShowToast(t('success_msg_successfully_logged_out'), TOAST_SUCCESS);
            history.replace('/');
        } 
        catch (error) {
            console.error('Error clearing app data.', error);
        }
    };

    /*
    to hind the logout icon on the subheader based on the path
  */
    const PathForHideLogout = (path)=>{
            if(path === "/parcel-pickup-door-verification"){
                return true;
            }
            else if(path === '/assignments'){
                return true;
            }
            else if(path === '/user-account' && !isAuthenticatedUser){
                return true;
            }
    }


    return (
        <Box className='sub-header header-container'>
            {!hide && (
                <IconButton id='back-button' edge="start" color="inherit" onClick={onPressHandler} aria-label="back">
                    {(t('backArrowWhiteIcon') !== 'backArrowWhiteIcon') ? (
                        <img className='back-image' src={t('backArrowWhiteIcon')} alt='back' />
                    ) : (
                        <Box className='back-icon-and-title'>
                            {colorScheme === 'dark' ? <DARK_MENU_BACK_ICON /> : <MENU_BACK_ICON />}
                            <Typography className='back-title' color="inherit"> {t('backBtnText')} </Typography>
                        </Box>
                    )}
                </IconButton>
            )}
            <Typography className='header-title' color={colorScheme === 'dark' ? APP_WHITE_COLOR : APP_ENGLISH_VIOLET_COLOR}> {getPageTitle(title)} </Typography>
           <Typography className='header-right' onClick={HandleShowModel}>
                {!PathForHideLogout(title) && (
                    (colorScheme === 'dark' || assignmentSettings?.usecase === "asset_rental")
                    ? <DARK_LOGOUT_ICON />
                    : <LOGOUT_ICON />
                )}
            </Typography>
            {/* Custom Dialog */}
                <CustomDialog
                    dialogId='error-dialog'
                    dialogVisible={isDialogVisible}
                    dialogTitle={dialogtitle}
                    dialogContentText={dialogMessage} 
                    buttonOneTitle={t('button_cancel')}
                    buttonTwoTitle={t('button_logout')}
                    buttonProps={{ 
                        buttonOne: { type: BUTTON_WARNING },                      
                        buttonTwo: { type: BUTTON_PRIMARY }
                    }}
                    handleCancel={() => {
                        setIsDialogVisible(false);
                        
                    }}
                    handleAccept={() => {
                        setIsDialogVisible(false);
                        handleLogout();
                }} 
            />

            {/* Back Button Transaction Cancellation Dialog (for drop-parcel page) */}
            <CustomDialog
                dialogId='back-transaction-dialog'
                dialogVisible={isBackDialogVisible}
                dialogTitle={dialogtitle}
                dialogContentText={dialogMessage} 
                buttonOneTitle={t('button_cancel')}
                buttonTwoTitle={t('button_logout')}
                buttonProps={{ 
                    buttonOne: { type: BUTTON_PRIMARY },                      
                    buttonTwo: { type: BUTTON_WARNING }
                }}
                handleCancel={() => {
                    setIsBackDialogVisible(false);
                    handleContinueWithoutCancel();
                }}
                handleAccept={handleBackDialogAccept} 
            />
        </Box>
    );
};

export default SubHeader;
